import { useAuthStore } from '../stores/auth-store'
import { requireAuthentication, resetAuthStore } from './middleware'

export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('../pages/login.vue'),
    beforeEnter: [resetAuthStore],
  },
  {
    path: '/enable-two-factor',
    name: 'auth.enable-two-factor',
    component: () => import('../pages/enable-two-factor.vue'),
    beforeEnter: requireAuthentication,
  },
  {
    path: '/verify',
    name: 'auth.verify',
    component: () => import('../pages/verify.vue'),
    beforeEnter: requireAuthentication,
  },
  {
    path: '/request-password-reset',
    name: 'request-password-reset',
    component: () => import('../pages/request-reset-password.vue'),
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('../pages/reset-password.vue'),
  },
  {
    path: '/request-two-factor-reset',
    name: 'request-two-factor-reset',
    component: () => import('../pages/request-two-factor-reset.vue'),
  },
  {
    path: '/reset-two-factor',
    name: 'reset-two-factor',
    component: () => import('../pages/reset-two-factor.vue'),
  },
  {
    name: 'request-email-verification',
    path: '/:slug/request-email-verification',
    component: () => import('../pages/requestEmailVerification.vue'),
  },
  {
    name: 'email-verification-instructions',
    path: '/:slug/email-verification-instructions',
    component: () => import('../pages/emailVerificationInstructions.vue'),
  },
  {
    name: 'verify-email',
    path: '/verify-email',
    component: () => import('../pages/verifyEmail.vue'),
  },
  // Unmatched paths are handled by the global catch-all in router.ts, which
  // redirects to /not-found. Don't duplicate it here — declaration order
  // would let the auth-routes catch-all win and bounce users to /login.
  //
  // Root gateway: an authenticated visitor (e.g. a company user opening
  // https://app.venture360.co directly) is bounced through the Rails redirect
  // handler, which routes by role — company users land on their company page
  // (tickets/2767). Unauthenticated visitors start at login as before.
  // The original query (e.g. ?slug=…&account=… from a workspace Login link)
  // is forwarded so Rails can route to the right group.
  {
    name: 'root',
    path: '/',
    beforeEnter: (to, _from, next) => {
      const authStore = useAuthStore()
      if (authStore.is_authenticated) {
        const query = new URLSearchParams(to.query as Record<string, string>).toString()
        window.location.href = `${import.meta.env.VITE_VENTURE360_REDIRECT_URL}/user${query ? `?${query}` : ''}`
        return
      }
      next({ name: 'login', query: to.query })
    },
  },
  {
    name: 'logout',
    path: '/logout',
    beforeEnter: [
      async (_to, _from, next) => {
        const authStore = useAuthStore()
        const hasValidToken = await authStore.validateToken()

        if (hasValidToken) {
          authStore.reset()
          window.location.href = `${import.meta.env.VITE_VENTURE360_SESSION_URL}/logout`
          return
        }

        authStore.reset()
        next({ name: 'login' })
      },
    ],
  },
]
